export const DOCUMENTS_COUNT_FOR_LOADING = 10;

export const LOADING_TIMEOUT = 1000;
